// extracted by mini-css-extract-plugin
module.exports = {"fullwidth":"_2p7fGRL","fullwidthVideo":"_3F1Nlhd","fullwidthCta":"_36XIGFE"};